import { useMemo, useState } from 'react';
import { difference } from 'lodash-es';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';
import { InsertSpecialistToHubList } from '@lp/features/modals/InsertSpecialistToHubModal/components';
import { HubsDataDictionary } from '@lp/features/Scheduler/types';
import { Hub, CSResource, CSResourcesWithShifts } from '@/api/apis/resources/schedule';

type InsertClinicalSpecModalProps = {
  hub: Hub;
  userList: CSResource[];
  shiftsData: CSResourcesWithShifts;
  hubsDictionary: HubsDataDictionary;
  onClose: () => void;
  onSave: (userIds: string[]) => void;
};

export const InsertSpecialistToHubModal = ({
  hub,
  userList,
  shiftsData,
  hubsDictionary,
  onClose,
  onSave,
}: InsertClinicalSpecModalProps) => {
  const userIds = useMemo(() => userList.map((user) => user.id), [userList]);
  const fullResourceList = useMemo(() => Object.values(shiftsData).map((r) => r.resource), [shiftsData]);
  const [selectedIds, setSelectedIds] = useState<string[]>(userIds);

  const handleSave = () => onSave(difference(selectedIds, userIds));

  return (
    <Modal
      isOpen
      classNames={{
        wrapper: 'flex-wrap',
        base: 'p-6 bg-base-80 m-2!',
        header: 'text-hl! font-secondary p-0 pb-4 border-b-1 border-base-30',
        body: 'p-0 my-6',
        footer: 'p-0 pt-6 border-t-1 border-base-30 justify-between',
      }}
      size="4xl"
      backdrop="opaque"
      onClose={onClose}
      scrollBehavior="inside"
      hideCloseButton
    >
      <ModalContent>
        <ModalHeader>Assign Clinical Specialist to {hub.name}</ModalHeader>
        <ModalBody>
          <div className="grow">
            <InsertSpecialistToHubList
              hubId={hub.id}
              resourceList={fullResourceList}
              hubsDictionary={hubsDictionary}
              insertedIds={userIds}
              selectedIds={selectedIds}
              onChange={setSelectedIds}
            />
          </div>
        </ModalBody>
        <ModalFooter className="justify-end">
          <div className="flex gap-3">
            <Button variant="outline" size="md" className="min-w-[160px]" onClick={onClose}>
              Discard
            </Button>
            <Button size="md" className="min-w-[160px]" onClick={handleSave}>
              Save Changes
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
